import StateHandler from './base/StateHandler';

const comRequireMap = {};
const comRequireSelect = [];

// 解析文件列表
function loadByFile(fileList) {
  fileList.keys().forEach(key => {
    const simpleName = key.substring(key.lastIndexOf('/') + 1, key.lastIndexOf('.'));
    const fileClass = fileList(key).default;
    comRequireMap[simpleName] = fileClass;
    comRequireSelect.push({
      id: simpleName,
      name: simpleName,
    });
  });
}

// 加载文件目录
const fileList = require.context('./store-module', false, /\.js$/);
loadByFile(fileList);

function initState(store) {
  StateHandler.loadFromOuter(store);

  comRequireSelect.forEach(item => {
    const moduleName = item.id;
    store.registerModule(moduleName, comRequireMap[moduleName]);
  });
}

export default {
  initState,
};